var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.83335H11.3334V4.50002C11.3334 2.66002 9.84002 1.16669 8.00002 1.16669C6.16002 1.16669 4.66669 2.66002 4.66669 4.50002V5.83335H4.00002C3.26669 5.83335 2.66669 6.43335 2.66669 7.16669V13.8334C2.66669 14.5667 3.26669 15.1667 4.00002 15.1667H12C12.7334 15.1667 13.3334 14.5667 13.3334 13.8334V7.16669C13.3334 6.43335 12.7334 5.83335 12 5.83335ZM6.00002 4.50002C6.00002 3.39335 6.89335 2.50002 8.00002 2.50002C9.10669 2.50002 10 3.39335 10 4.50002V5.83335H6.00002V4.50002ZM12 13.8334H4.00002V7.16669H12V13.8334ZM8.00002 11.8334C8.73335 11.8334 9.33335 11.2334 9.33335 10.5C9.33335 9.76669 8.73335 9.16669 8.00002 9.16669C7.26669 9.16669 6.66669 9.76669 6.66669 10.5C6.66669 11.2334 7.26669 11.8334 8.00002 11.8334Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f4cb9b10.svg";
export { ForwardRef as ReactComponent };